import type { EntityConfig } from "@/v2/framework/registry/types";
import { createSportsView } from "./grid/view";

export default {
  id: "sports",
  name: "sports",
  title: "metadata.sports",
  position: 1,
  create: (ctx) => createSportsView(ctx),
} satisfies EntityConfig;
